<script lang="ts">

    export let date: Date;

    let dateString: string;

    $: dateString = dateFormat(date);

    function dateFormat(date: Date): string {
        return Intl.DateTimeFormat('es-ES').format(date);
    }

</script>

{dateString}